// extracted by mini-css-extract-plugin
export default {"userDetailsHeader":"employes_userDetailsHeader__Fcqzy","spinner":"employes_spinner__ovh21","addButtonSticky":"employes_addButtonSticky__a-+bW"};